import {WorkflowTargetModel} from "../workflow/models/workflow-target.model";

export interface DeviceRelocationModel extends WorkflowTargetModel {
  id?: string;
  name?: string;

  assetsCount?: number;
  siteId?: string;
  siteName?: string;
  projectName?: string;
  projectId?: string;
  workflowId?: string;
  closed?: boolean;
  defectProgressPercentageBar?: {title: string, value: number, type: string, width: number};

  deploymentId?: string;
  deploymentName?: string;
}

export function defectProgressPercentageBarModelFactory(json?: any) {
  if (!json || !json.defectProgressPercentageBar) return {title: "", value: 0, type: "bg-info", width: 0};

  return {
    title: json.defectProgressPercentageBar.title,
    value: +json.defectProgressPercentageBar.value,
    type: json.defectProgressPercentageBar.type,
    width: +json.defectProgressPercentageBar.width,
  };
}

export function deviceRelocationModelFactory(json?: any): DeviceRelocationModel {
  json = json || {};
  return {
    id: json.id,
    name: json.name,

    assetsCount: +json.assetsCount,
    projectName: json.projectName,
    projectId: json.projectId,
    siteId: json.siteId,
    siteName: json.siteName,
    workflowId: json.workflowId,
    closed: json.closed,
    defectProgressPercentageBar: defectProgressPercentageBarModelFactory(json),

    deploymentId: json.deploymentId || "",
    deploymentName: json.deploymentName || "",
  };
}

export function deviceRelocationModelListFactory(json?: any) {
  json = json || [];
  return Array.from(json).map(it => deviceRelocationModelListFactory(it));
}
